module.exports = __webpack_public_path__ + "img/2025-06-11d_2.832e5178.jpg";